module.exports = __webpack_public_path__ + "static/media/tap_04_img01.4641af46.png";